import {
  TagPicker as FluentTagPicker,
  TagPickerProps as FluentTagPickerProps,
} from '@fluentui/react-components';
import React from 'react';
import { useFluentMountNode, useInputAppearance } from '../hooks';
import './TagPicker.scss';

export type TagPickerProps = FluentTagPickerProps;

/**
 * Themed TagPicker wrapper that automatically applies the correct
 * filled appearance based on the current theme (dark/light).
 *
 * The popover list is mounted inside #portal-root (within FluentProvider)
 * so that all theme tokens are inherited correctly — same pattern as
 * Popup, Tooltip, and LocalizedFormDatePicker.
 *
 * Note: The TagPickerList background still requires a separate wrapper
 * (see TagPickerList.tsx) because Fluent UI's Listbox does not apply
 * appearance-based backgrounds.
 */
export const TagPicker: React.FC<TagPickerProps> = ({ appearance, ...props }) => {
  const themedAppearance = useInputAppearance();
  const mountNode = useFluentMountNode();

  return (
    <FluentTagPicker
      appearance={appearance ?? themedAppearance}
      {...props}
      // mountNode is supported at runtime via useComboboxBaseState but not
      // included in TagPickerProps. Cast to pass it through safely.
      {...({ mountNode } as Record<string, unknown>)}
    />
  );
};

TagPicker.displayName = 'TagPicker';
